import { createEl, createImageEl } from "../../../helpers/dom-creators.js";
import { $ } from "../../../helpers/dom-selectors.js";
import emitGlobalFileEventWithData from "../../../helpers/file-upload/file-upload-events.js";
export default function makeFileForms({ wrappers }) {
    let initialized = false;
    const FILE_FORMS = [];
    let lastTarget = null;
    return Object.freeze({
        init,
        show,
        hide,
        showFile,
        add,
        reset,
        setURL,
        update,
        getURL,
        remove
    });
    function _findByIndex(index) {
        return FILE_FORMS.find(form => form.id === index);
    }
    function init() {
        if (initialized)
            return;
        for (let i = 0; i < wrappers.length; i++) {
            FILE_FORMS.push(_newForm(wrappers[i], i));
            _addListeners(FILE_FORMS[i]);
        }
        initialized = true;
    }
    // ---------- ADD NEW FORM
    function _newForm(wrapper, i) {
        return {
            id: i,
            wrapper,
            formId: wrapper.getAttribute('data-id'),
            dropZone: $(wrapper, '.dropzone')[0],
            placeHolder: $(wrapper, '.file-placeholder')[0],
            fileInput: $(wrapper, `input[type="file"]`)[0],
            cancelFileBtn: $(wrapper, '.remove-file-btn')[0],
            fileBox: $(wrapper, '.file-reveal')[0],
            fileName: $(wrapper, '.file-name')[0],
            sendBtn: $(wrapper, '.send-btn')[0],
            uploadFile: null,
            fileURL: wrapper.getAttribute('data-src'),
        };
    }
    function add(id) {
        const wrappers = $(document, '.form');
        const newForm = _newForm(wrappers[wrappers.length - 1], id);
        newForm.fileURL = null;
        newForm.formId = null;
        _removeImg(newForm.wrapper);
        FILE_FORMS.push(newForm);
        reset(id);
        _addListeners(newForm);
    }
    function _addListeners(form) {
        form.fileInput.addEventListener('change', (e) => {
            const target = e.currentTarget;
            _onFileInput(form, target.files);
        });
        ;
        form.dropZone.addEventListener('dragover', (e) => e.preventDefault());
        form.dropZone.addEventListener('dragenter', (e) => { lastTarget = e.target; _onDragEnter(form); });
        form.dropZone.addEventListener('dragleave', (e) => { if (e.target === lastTarget)
            _onDragLeave(form); });
        form.dropZone.addEventListener('drop', (e) => {
            e.preventDefault();
            _onDrop(form, e.dataTransfer?.files[0]);
        });
        form.cancelFileBtn.addEventListener('click', (e) => reset(form.id));
        form.sendBtn.addEventListener('click', (e) => _sendFile(form));
    }
    function reset(index) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.fileInput.value = ''; //FOR WHEN USER WANTS TO BROWSE AND SELECT SAME FILE THAT WAS PREVIOUSLY SELECTED
        form.uploadFile = null;
        form.sendBtn.disabled = true;
        form.fileBox.classList.add('no-display');
        form.fileName.innerText = '';
    }
    // ---------- SHOW VALID FILE INPUT
    function showFile(index, fileName) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.sendBtn.disabled = false;
        form.fileBox.classList.remove('no-display');
        form.fileName.innerText = fileName;
    }
    // ---------- SEND FILE
    function _sendFile(form) {
        if (!form.uploadFile)
            return;
        emitGlobalFileEventWithData('file-sent', { id: form.id, file: form.uploadFile });
    }
    // ---------- UPDATE FILE INPUT
    function setURL(index, url) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.fileURL = url;
    }
    function update(index, formEl, formId) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.formId = formId;
        _createImgFromUpload(form.dropZone, formEl, form.fileURL);
    }
    // ---------- CREATE & REMOVE IMAGE
    function _createImgFromUpload(dropZone, form, src) {
        if (!src)
            return;
        const imgWrapper = $(form, '.img-wrapper')[0];
        if (imgWrapper) {
            const img = $(imgWrapper, '.uploaded-img')[0];
            img.src = src;
            return;
        }
        const newImg = _createImg(src);
        dropZone.parentElement?.before(newImg);
    }
    function _createImg(src) {
        const wrapper = createEl('div', 'width-100 img-wrapper');
        wrapper.append(createImageEl('uploaded-img', { src, alt: '' }));
        return wrapper;
    }
    function _removeImg(form) {
        const imgEl = $(form, '.img-wrapper')[0];
        if (imgEl)
            imgEl.remove();
    }
    function getURL(index) {
        const form = _findByIndex(index);
        if (!form)
            return null;
        return form.fileURL;
    }
    // ---------- SHOW/HIDE FORM
    function show(index) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.dropZone.classList.remove('no-display');
    }
    function hide(index) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.dropZone.classList.add('no-display');
        reset(index);
    }
    // ---------- REMOVE
    function remove(id) {
        const formIndex = FILE_FORMS.findIndex(form => form.formId === id);
        if (formIndex === -1)
            return;
        FILE_FORMS.splice(formIndex, 1);
    }
    // ---------- ON FILE BROWSE / DRAG & DROP
    function _onFileInput(form, files) {
        if (!files) {
            reset(form.id);
            return;
        }
        const file = files[0];
        if (!file) {
            reset(form.id);
            return;
        } // when user hits cancel from native "browse file" window 
        form.uploadFile = file;
        emitGlobalFileEventWithData('file-inputted', { id: form.id, file });
    }
    function _onDragEnter(form) {
        form.dropZone.classList.add('dropzone-change');
        form.placeHolder.innerText = 'Drop file...';
    }
    function _onDragLeave(form) {
        form.dropZone.classList.remove('dropzone-change');
        form.placeHolder.innerText = 'Drag and drop file';
    }
    function _onDrop(form, file) {
        _onDragLeave(form);
        if (!file) {
            reset(form.id);
            return;
        }
        form.uploadFile = file;
        emitGlobalFileEventWithData('file-inputted', { id: form.id, file });
    }
}
